import { render, staticRenderFns } from "./LandingProcess.vue?vue&type=template&id=4933d0fe&scoped=true"
import script from "./LandingProcess.vue?vue&type=script&lang=js"
export * from "./LandingProcess.vue?vue&type=script&lang=js"
import style0 from "./LandingProcess.vue?vue&type=style&index=0&id=4933d0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4933d0fe",
  null
  
)

export default component.exports